export default __webpack_public_path__ + "static/media/review-place-blue.ef40c7eb.svg";